<template>
	<el-container>
		<!-- <el-header class="greenmenu">
			<span @click="$router.back(-1)" class="backstr">
				<返回</span> <span class="header_h2">个人信息
			</span>
		</el-header> -->
		<el-header>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="toback()" :src='"/img/webimg/back.png"' alt=""> -->
			<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="toback()" icon="el-icon-arrow-left" type="text"></el-button>
			<span class="header_h2">个人信息 </span>
		</el-header>
		<!-- 品牌：<el-select style=" width: 200px;  height:30px;" v-model="curcorpid" placeholder="请选择">
			<el-option v-for="item in CorpData" :label="item.corp_name" :value="item.corp_id">
				{{ item.corp_name }}
			</el-option>
		</el-select> -->
		<el-row type="flex" justify="center">
			<div style=" width: 350px;margin-top: 20px;">
			<el-form width='95%' size="mini" :model="EditInfo" ref="EditInfo" label-width="80px">
				<el-form-item label="姓名" required>
					<el-input size="mini" v-model="EditInfo.cusname"></el-input>
				</el-form-item>
				<el-form-item label="性别" required>
					<el-radio v-model="EditInfo.cussex" label="1">男</el-radio>
					<el-radio v-model="EditInfo.cussex" label="2">女</el-radio>
				</el-form-item>
				<el-form-item label="婚否" required>
					<el-radio-group size="mini" v-model="EditInfo.cusmarry">
						<el-radio-button :label="1">已婚</el-radio-button>
						<el-radio-button :label="2">未婚</el-radio-button>
					</el-radio-group>
					<!-- <el-select size="mini" v-model="EditInfo.cusmarry">
						<el-option v-for="item in this.$enums.Marry" :label="item.key" :value="item.value" placeholder="请选择">
							{{ item.key }}
						</el-option>
					</el-select> -->
				</el-form-item>
				<el-form-item label="出生日期"  required>
					<el-date-picker type="date" size="mini" v-model="EditInfo.cusbirthday" format="yyyy-MM-dd"></el-date-picker>
					<!-- <el-input  type='date' ></el-input> -->
				</el-form-item>
				<el-form-item label="身份证号">
					<el-input size="mini" v-model="EditInfo.idcard"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input size="mini" v-model="EditInfo.memo"></el-input>
				</el-form-item>
				
			</el-form>
		</div>
		</el-row>
		<el-row>
			<button class="bluebutton" @click="btnEditCus()">下一步</button>
		</el-row>
	</el-container>
</template>

<script>
	import order from '../../apifunction/Order.js'
	import ordercus from '../../apifunction/OrderCus.js'
	import checkidcard from '../../commontools/checkIDcard.js'
	import goods from '../../apifunction/Goods.js'
	export default {
		data() {
			return {
				emSex: this.$enums.Sex,
				emMarry: this.$enums.Marry,
				cusent: null,
				orderent: null,
				GoodsData: [],
				EditInfo: {
					id: '',
					cusname: '',
					cussex: '1',
					cusbirthday: '',
					cusmarry: '3',
					mobile: '',
					idcard: '',
					cusstatus: '10',
					memo: '',
					orderid: '',
					groupid: '',
					corpid: ''
				},
			}
		},
		created() {
			var ent = this.$route.query.ent;
			this.cusent = JSON.parse(ent);
			this.InitData();
			// if (this.cusent.corpid == '')
			// 	this.InitCorp();

		},
		methods: {
			toback()
			{
					var data = {
						path: '/BookCusList',
						query: {
							mobile: this.cusent.mobile
						}
					}
					this.$router.push(data)
			
			},
			InitData() {
				this.setcusinfo(this.cusent);
				this.InitGoods();
				this.idcardonblur();
			},
			InitGoods() {
				goods.GetGoodsByCusID(this.cusent.id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.GoodsData = JSON.parse(ent.Data);
							}
						}
					});
			},
			idcardonblur() {
				let b = checkidcard.checkCard(this.cusent.idcard);
				if (b) {
					this.cusent.cusbirthday = checkidcard.baseInfo.birthday;
					this.cusent.cussex = checkidcard.baseInfo.sex;
				}


			},
			setcusinfo() {
				ordercus.GetOrderCusByCusID(this.cusent.id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								let row = JSON.parse(ent.Data)[0];
				this.EditInfo = {
					id: row.id,
					cusname: row.cusname,
					cussex: row.cussex,
					cusbirthday: row.cusbirthday,
					cusmarry: row.cusmarry,
					mobile: row.mobile,
					idcard: row.idcard,
					cusstatus: row.cusstatus,
					memo: row.memo,
					orderid: row.orderid,
					groupid: row.groupid,
					corpid: row.corpid
				};
				}}})
			},
			btnEditCus() {
				if (this.EditInfo.cusname==""|| this.EditInfo.cussex=="" || this.EditInfo.cusbirthday==""||(this.EditInfo.cusmarry!='1'&&this.EditInfo.cusmarry!='2')) {
						
					this.$message.info('请填写姓名、性别、婚否及出生日期！');
					return;
				}
				if (this.GoodsData.length > 0) {
					for (let i = 0; i < this.GoodsData.length; i++) {
						if (this.GoodsData[i].adaptsex != '3' && this.GoodsData[i].adaptsex != this.EditInfo.cussex) {
							this.$message.info('性别与体检套餐不符！')
							return;
						}
					}
				}
				this.EditInfo.cusbirthday=this.CommonFun.formatdate(this.EditInfo.cusbirthday)
				ordercus.EditCus(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.SaveSingleCusItems();

						} else
							this.$message.info(ent.Msg);
					})
			},
			SaveSingleCusItems() {
				ordercus.SaveSingleCusItems(this.EditInfo.id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {

							var data = {
								path: '/SelBookBranch',
								query: {
									ent: JSON.stringify(this.EditInfo)
								}
							};
							this.$router.push(data)

						} else
							this.$message.info(ent.Msg);
					})
			}
		}
	}
</script>

<style>
</style>
